























































































































































































































import { inject } from "inversify-props";
import { Component, Vue } from "vue-property-decorator";
import DoctorEditor from "@/components/DoctorEditor.vue";
import DoctorRegisterCard from "@/components/DoctorRegisterModal.vue";
import DoctorInvitationCard from "@/components/DoctorInvitationModal.vue";
import MassActionPerformModal, { MassActionItem } from '@/components/MassActionPerformModal.vue';
import { DoctorModel } from "@/models/doctor";
import { doctor as doctorStore } from "@/store/modules";
import { IDoctorService } from '@/interfaces/Services';
import DependencyIdentifiers from '@/ioc/DependencyIdentifiers';
import LambdaDownloader from "@/utils/lambda_downloader";

enum DoctorActionable {
  Recovery = 'Recovery',
  Register = 'Register',
  Invite = 'Invite'
}

@Component({
  components: {
    DoctorEditor,
    DoctorRegisterCard,
    DoctorInvitationCard,
    MassActionPerformModal,
  }
})
export class Doctors extends Vue {
  @inject(DependencyIdentifiers.DoctorService)
  private doctorService!: IDoctorService;

  registerModal = false;
  registerInProgress = false;
  doctorsToBeRegistered: DoctorModel[] = [];

  private recoveryModal = {
    visible: false,
    inProgress: false,
    queue: [] as MassActionItem[]
  }; 

  private register(doctors: DoctorModel[]) {
    this.doctorsToBeRegistered = [...doctors];
    this.registerInProgress = true;
    this.registerModal = true;
  }

  onRegisterComplete() {
    this.registerInProgress = false;
  }

  onRegisterModalClose() {
    this.doctorsToBeRegistered = [];
    this.refresh();
  }  
  
  invitationModal = false;
  invitationInProgress = false;
  doctorsToBeInvited: DoctorModel[] = [];
  
  private invite(doctors: DoctorModel[]) {
    this.doctorsToBeInvited = [...doctors];
    this.invitationInProgress = true;
    this.invitationModal = true;
  }

  onInvitationComplete() {
    this.invitationInProgress = false;
  }

  onInvitationModalClose() {
    this.doctorsToBeInvited = [];
    this.refresh();
  }

  private addNew = false;
  private componentKey = 0;
  private async refresh() {
    this.isLoading = true;
    try {
      let size = 100,
        page = 1,
        total = 0;
      do {
        const [items, {}] = await this.doctorService.getMany(page, size);
        this.items = [...items];
      } while (page * size < total);
    } finally {
      this.isLoading = false;
    }
  }

  onOpenCreate() {
    this.addNew = true;
    this.selected = [];
  }

  openEditor(id: string) {
    for (const item of this.items) {
      if (item.$id === id) {
        this.selected = [item];
        return;
      }
    }
  }

  async onSelect() {
    this.addNew = false;
  }

  async onCancel() {
    this.addNew = false;
    this.selected = [];
  }

  async onCreated(model: DoctorModel) {
    await this.refresh();
    this.addNew = false;
    this.selected = [model];
  }

  private selected: DoctorModel[] = [];
  private get headers() {
    return [
      {
        text: this.$t('doctor.fields.name'),
        align: "left",
        sortable: true,
        value: "name"
      },
      {
        text: this.$t('doctor.fields.contactPhone'),
        align: "left",
        sortable: true,
        value: "contactPhone"
      },
      {
        text: this.$t('doctor.fields.contactEmail'),
        align: "left",
        sortable: true,
        value: "contactEmail"
      },
      {
        text: "",
        value: "action",
        sortable: false,
        align: "right"
      }
    ];
  }
  private isLoading = true;
  private items: Array<any> = [];
  private search: string = "";

  async mounted() {
    this.refresh();
  }

  recovery(items: DoctorModel[]) {
    this.recoveryModal.queue = [...items].map<MassActionItem>((item: DoctorModel) => {
      return {
        model: item,
        identifier: `${item.name} (${item.contactEmail})`,
        getActionResult: async () => item,
      };
    });
    this.recoveryModal.inProgress = true;
    this.recoveryModal.visible = true;
  }

  private isSelectedActionable(
    items: DoctorModel[],
    check: DoctorActionable,
    matchAll: boolean = true,
  ): boolean {
    let matchCount: number = 0;
    items.forEach((item) => {
      if (!item) {
        return;
      }
      switch (check) {
        case DoctorActionable.Register:
        case DoctorActionable.Invite:
          if (!item.$isRegisteredUser) {
            matchCount++;
          }
          break;
        case DoctorActionable.Recovery:
          if (item.$isRegisteredUser) {
            matchCount++;
          }
          break;
        default:
          throw new Error(`Unknown [DoctorActionable.${check}].`);
          break;
      }
    });

    return matchAll ? matchCount == items.length : matchCount > 0;
  }

  onRecoveryComplete() {
    this.recoveryModal.inProgress = false;
  }

  onRecoveryModalClose() {
    this.recoveryModal.queue = [];
    this.recoveryModal.visible = false;
    this.recoveryModal.inProgress = false;
    this.refresh();
  }

  async downloadRecoveryKey(email: string, recoveryKey: string) {
    if (this.isLoading) {
      return;
    }

    const download = new LambdaDownloader(
      {key: recoveryKey, email},
      'recovery-key-to-pdf',
      `hemonaplo-recovery-${email}`,
      (isLoading) => this.isLoading = isLoading
    );
    await download.start();
  }
}

export default Doctors;
